import http from './http';

export default {
  register(payload) { return http.post('/auth/register', payload).then((r) => r.data.data); },
  login(payload) { return http.post('/auth/login', payload).then((r) => r.data.data); },
  me() { return http.get('/auth/me').then((r) => r.data.data); },
  forgotPassword(payload) { return http.post('/auth/forgot-password', payload).then((r) => r.data.data); },
  resetPassword(payload) { return http.post('/auth/reset-password', payload).then((r) => r.data.data); },
  appeal(payload) { return http.post('/auth/appeal', payload).then((r) => r.data.data); },
};
